import api from 'app/api';
import getAllWithJoin from './get-orders-with-join';
import getOrder from './get-order';
import edirOrder from './edit-order';

export const ordersApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getOrder: getOrder(builder),
        getOrdersWithJoin: getAllWithJoin(builder),
        editOrder: edirOrder(builder),
    }),
});

export const { useGetOrdersWithJoinQuery, useGetOrderQuery, useEditOrderMutation } = ordersApi;
